import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import * as Const from 'util/constants';
import './SearchKeywords.scss';
import { asyncSearchForBundles } from 'actions/bundles';
import { asyncSearchForTemplates } from 'actions/templates';

const MAX_KEYWORDS = 20;

export class SearchKeywords extends Component {
  static propTypes = {
    type: PropTypes.string.isRequired,
    title: PropTypes.string,
    keywords: PropTypes.arrayOf(PropTypes.string).isRequired
  };

  onSelectKeyword = keyword => {
    const { type, searchForTemplates, searchForBundles } = this.props;
    if (type === Const.TYPE_TEMPLATES) searchForTemplates(keyword);
    else searchForBundles(keyword);
  };

  render() {
    const { type, title, keywords } = this.props;
    const keywordsData = keywords.slice(0, MAX_KEYWORDS);
    return (
      <div className="search-keywords">
        <div className="spacing-helper">
          {title && <span className="title">{title}</span>}
          {keywordsData.map(
            keyword =>
              keyword !== '' && (
                <Link to={`/${type}/${keyword}`} key={keyword} onClick={() => this.onSelectKeyword(keyword)}>
                  {keyword}
                </Link>
              )
          )}
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({});

const mapDispatchToProps = dispatch => ({
  searchForBundles: term => dispatch(asyncSearchForBundles(term)),
  searchForTemplates: term => dispatch(asyncSearchForTemplates(term))
});

export default connect(mapStateToProps, mapDispatchToProps)(SearchKeywords);
